import React from 'react';
import { useCallback, useMemo } from 'react';

import { BreadcrumbItem, StyledBreadcrumb } from './styles';
import { ReactComponent as ArrowLeft } from '../../assets//novosicones/arrow_back.svg';
const Breadcrumb = ({ paths, handleBack, selectPath, currentPath }) => {
  const isCurrentPath = useCallback(
    (path) => {
      return currentPath === path;
    },
    [currentPath]
  );

  const hasPaths = useMemo(() => {
    return paths && paths?.length > 0;
  }, [paths]);

  return (
    <StyledBreadcrumb>
      <div className='back-title'>
        {handleBack && <ArrowLeft onClick={handleBack} />}

        <div className='paths'>
          {hasPaths &&
            paths.map((path, index) => {
              return (
                <BreadcrumbItem
                  key={path.id}
                  $isCurrentPath={currentPath === path.nome}
                >
                  {index > 0 && <span> / </span>}
                  <span
                    className='path-name'
                    onClick={() =>
                      !isCurrentPath(path.nome) && selectPath(path)
                    }
                  >
                    {path.nome}
                  </span>
                </BreadcrumbItem>
              );
            })}
        </div>
      </div>
    </StyledBreadcrumb>
  );
};

export default Breadcrumb;
